export default {
  computed: {
    widthWindow () {
      return window.innerWidth
    }
  }
}
